import type { EnrichedSwarovskiProductVariantFrontend } from "@swo/storefront";
import type { BundlePDPVariant } from "./BundleProduct";
import type { BundleVariantSelection } from "./BundleVariantSelection";
import type { BundlePageProps } from "./product-detail-page-layout";
import { pipe } from "fp-ts/lib/function";
import { nonEmptyArray as NEA } from "fp-ts";
import type { ProductVariantAvailabilityStatus } from "@swo/shared";

export function getDefaultVariantsSelection(
  selectedProduct: BundlePageProps["data"]["selectedProduct"],
  availabilityMap: Map<string, ProductVariantAvailabilityStatus> | "shopping-not-possible",
): BundleVariantSelection {
  return pipe(
    selectedProduct.products,
    NEA.map(p => {
      const key = p.key;

      const valueSku = p.preselectedVariant?.sku;

      const fallbackVariant: EnrichedSwarovskiProductVariantFrontend = p.variants[0];
      const value: EnrichedSwarovskiProductVariantFrontend = valueSku
        ? (p.variants.find(v => v.sku === valueSku) ?? fallbackVariant)
        : fallbackVariant;

      if (!value.attributes) {
        throw Error("Cannot use bundle product without attributes");
      }

      const variant: BundlePDPVariant = {
        ...value,
        attributes: value.attributes,
        product: { name: p.name, images: p.images, shortDescription: p.shortDescription },
        availability:
          typeof availabilityMap !== "string"
            ? (availabilityMap.get(value.sku) ?? { tag: "out-of-stock" })
            : { tag: "out-of-stock" },
      };

      return { key, value: variant };
    }),
  );
}
